import classNames, { Argument } from 'classnames';
import { FC } from 'react';

import { ImageWithFallback } from '../../../ImageWithFallback';

interface ImageListItemProps {
  className?: Argument;
  description?: string;
  imageUris?: string[];
  subtitle?: string;
  title: string;
  variant?: 'product';
  unoptimized?: boolean;
}

export const ImageListItem: FC<ImageListItemProps> = ({
  className,
  description,
  imageUris,
  subtitle,
  title,
  unoptimized = false,
  variant,
}) => (
  <div
    className={classNames(
      'flex items-center justify-center space-x-3',
      className,
    )}
  >
    <div className={classNames('relative h-12 w-12 shrink-0 rounded-sm')}>
      {imageUris && (
        <ImageWithFallback
          alt={title}
          className="overflow-hidden rounded-sm mix-blend-multiply"
          fallbackSrc={imageUris.length > 0 ? imageUris[1] : ''}
          src={imageUris[0]}
          unoptimized={unoptimized}
          width={48}
        />
      )}
    </div>
    <div className="flex flex-1 flex-col overflow-hidden">
      <div
        className={classNames(
          'truncate transition-colors duration-300 group-hover:text-neutral-4',
          {
            'font-bold': variant === 'product',
          },
        )}
      >
        {title}
      </div>
      {(subtitle || description) && (
        <div className="flex w-full flex-1 flex-nowrap items-center overflow-hidden text-neutral-4">
          <div className="flex-1 truncate">{subtitle}</div>
          <div className="shrink-0">{description}</div>
        </div>
      )}
    </div>
  </div>
);
